import {first} from 'lodash';
import {Logger} from './utils/Logger';
import {FormGroupUtil} from './utils/FormGroupUtil';
import {AbstractControl, FormGroup} from '@angular/forms';

export abstract class ErrorHandlingComponent {
    public getErrorMessage(control: AbstractControl): string {
        const controlName = this.getControlName(control);
        const errors = this.errorMessages();
        const message = '';
        if (control.errors) {
            const occurredError = first(Object.keys(control.errors));
            const predefinedErrorsForControl = errors[controlName];
            const result = predefinedErrorsForControl.find(predefinedError => predefinedError.type === occurredError);
            if (result) {
                return result.message;
            } else {
                Logger.log(`Could not find error message for error: ${occurredError}`);
            }
        }
        return message;
    }

    protected errorMessages(): object {
        return {};
    }

    protected isValid(formGroup: FormGroup) {
        FormGroupUtil.validateFormGroup(formGroup);
        return formGroup.valid;
    }

    private getControlName(c: AbstractControl): string | null {
        const formGroup = c.parent.controls;
        return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    }
}